module.exports = __webpack_public_path__ + "static/media/C1.653e2acb.jpg";